// extracted by mini-css-extract-plugin
export default {"customer-support-tel-link":"error_customer-support-tel-link__+5LjL","back-button":"error_back-button__8704F","fullView":"error_fullView__WAZOg","shimmer":"error_shimmer__LQVcQ"};